import { Dialog, DialogFooter, DialogType } from "office-ui-fabric-react";
import * as React from "react";

export interface DialogBoxProps {
    hidden: boolean;
    type: DialogType;
    title: string;
    subText: string;
    onDismiss(): void;
}

export interface DialogBoxState {
}

export default class DialogBox extends React.Component<DialogBoxProps, DialogBoxState> {

    constructor(props: Readonly<DialogBoxProps>) {
        super(props);

        this.state = {
        };
    }


    public render() {
        return (
            <Dialog
                hidden={this.props.hidden}
                onDismiss={this.props.onDismiss}
                dialogContentProps={{
                    type: this.props.type,
                    title: this.props.title,
                    subText: this.props.subText
                }}
                modalProps={{
                    isBlocking: false,
                    styles: {
                        main: { maxWidth: 900, width: 800 }},
                }}>
                <DialogFooter>
                    {this.props.children}
                </DialogFooter>
            </Dialog>
        );
    }
}